import { Button, OptionTile } from "@manifesthhqinc/ui-library";
import { ErrorText, TitleLarge } from "../../../components/font";
import Footer from "../../../components/footer";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import Container from "../../../layout/container";
import ScrollableContainer from "../../../layout/scrollable-container";
import { OptionTileContainer } from "../../henry-questionniare/screens/styles";
import { UseExploreIRAOptionsType } from "../useExploreIRAOptions";
import { ESG, FAMILY, NONE, SIGN_UP_BONUS } from "../../../class/iraQuestionnaire";
import HeadingContainer from "../../../layout/heading-container";

const ExploreIRAOptionQuestionTwo = (props: UseExploreIRAOptionsType) => {
  const { onClickContinue, extraFeatures, updateExtraFeature, formValidation } = props;
  return (
    <TransitionWrapper>
      <ScrollableContainer name="henry-questionnaire-form-2">
        <Container>
          <HeadingContainer paneVariant="optionForm" withProgressBar>
            <TitleLarge>Do any of these extras matter to you?</TitleLarge>
            {formValidation.extras && <ErrorText>{formValidation.extras}</ErrorText>}
          </HeadingContainer>
          <OptionTileContainer>
            <OptionTile
              variant="checkbox"
              appearance="secondary"
              onChange={() => updateExtraFeature(SIGN_UP_BONUS)}
              isSelected={extraFeatures.includes(SIGN_UP_BONUS)}
            >
              Sign-up bonuses or contribution matches
            </OptionTile>
            <OptionTile
              variant="checkbox"
              appearance="secondary"
              onChange={() => updateExtraFeature(FAMILY)}
              isSelected={extraFeatures.includes(FAMILY)}
            >
              Tools for saving with your family
            </OptionTile>
            <OptionTile
              variant="checkbox"
              appearance="secondary"
              onChange={() => updateExtraFeature(ESG)}
              isSelected={extraFeatures.includes(ESG)}
            >
              ESG or values-aligned investing
            </OptionTile>
            <OptionTile
              variant="checkbox"
              appearance="secondary"
              onChange={() => updateExtraFeature(NONE)}
              isSelected={extraFeatures.length === 1 && extraFeatures.includes(NONE)}
              name="none"
            >
              None of these really matter to me
            </OptionTile>
          </OptionTileContainer>
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button name="continue" onClick={() => onClickContinue()} size="large">
          Continue
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default ExploreIRAOptionQuestionTwo;
